import { Injectable, inject, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Utilities } from "@app/core/utils/utilities";
import { CourseListingPageComponent } from "../course-listing-page/course-listing-page.component";
import { Router } from "@angular/router";
import { ReportListingPopupComponent } from "@app/shared/components/report-listing-popup/report-listing-popup.component";
import { UploadReportComponent } from "@app/pages/subject-report/upload-report/upload-report.component";
import { EasyLoadService } from "@app/shared/services/easy-load.service";
import { ReportConstants } from "@app/pages/subject-report/util/report-constants";
import { take } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CourseCommonFunctions {
  private dialog = inject(MatDialog);
  util = inject(Utilities);
  router = inject(Router);
  easyLoadService = inject(EasyLoadService);
  reportConstants = inject(ReportConstants);
  successMessage$ = signal<string>('');
  courseGroupTypeDetails$ = signal<any>('');
  stageCount$ = signal<any>(0);
  reloadInstancePage$ = signal<any>(false);
  relatedCourseCount = signal<number>(0);
  instanceAttributeFields = signal<any[]>([]);

  compareFn(srcObj: any, selectedObj: any) {
    if (srcObj && selectedObj)
      if (Object.hasOwn(srcObj, 'departmentId') && Object.hasOwn(selectedObj, 'departmentId'))
        return srcObj.departmentId === selectedObj.departmentId;
      else
        return srcObj.id === selectedObj.id;
    else
      return srcObj === selectedObj;
  }

  openRelatedInstanceDialog(courseData: any, componentName: any, panelClassName: any, pageType?: string) {
    this.util.isDialogOpen$.set(true);
    const dialogRef = this.dialog.open(componentName, {
      data: courseData,
      panelClass: panelClassName
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response?.status === 'success' && pageType === 'courseGroupType') {
        this.successMessage$.set(response.message);
        this.courseGroupTypeDetails$.set(response.data)
        document.getElementById('create_course')?.scrollIntoView({ behavior: "smooth", block: "start" })
        setTimeout(() => {
          this.successMessage$.set('');
        }, 5000);
      }
      this.util.isDialogOpen$.set(false);
    })
  }

  getUserData(fieldData: any, pageName?: string) {
    if (this.util.getStoredUserDetails().userId) {
      const field = (pageName?.includes('add')) ? 'createdBy' : 'updatedBy';
      fieldData[field] = Number(this.util.getStoredUserDetails().userId);
    }
  }

  getFilteredValues(values: any, countryData: any, courseTypeId: any, from?: string) {
    return values?.filter((val: any) => {
      if (from === 'course') {
        let returnFlag = null;
        if ('countryId' in val) returnFlag = this.getCountryFlag(val, countryData);
        if ('courseTypeId' in val) return (returnFlag && (val?.courseTypeId === Number(courseTypeId)));
        else return returnFlag ?? val;
      } else {
        if (from === 'flags') val['selectedFlag'] = false;
        if (val?.countryId) return val?.countryId === countryData;
        else if ('parentCourseTypeId' in val) return (val?.parentCourseTypeId === Number(courseTypeId));
        else return val;
      }
    });
  }

  getCountryFlag(data: any, countryData: any) {
    if (countryData?.dataStandardId === 999)
      return data?.countryId?.length ? (data.countryId.filter(Boolean).length !== data.countryId.length) : ((data?.countryId === countryData?.countryId) || !data?.countryId);
    return data?.countryId?.length ? data.countryId.includes(countryData?.countryId) : (data?.countryId === countryData?.countryId);
  }

  parseDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr?.split('/')?.map(Number) ?? null;
    if (day && month && year) return new Date(year, month - 1, day);
    else return null;
  }

  openCoursePopup(data: any, instanceId?: any, currentErTab?: any) {
    this.util.isDialogOpen$.set(true);
    if (instanceId)
      data['instanceId'] = instanceId;
    if (currentErTab)
      data['currentErTab'] = currentErTab;
    const dialogRef = this.dialog.open(CourseListingPageComponent, {
      panelClass: 'er-assign-course-popup',
      width: '1114px',
      data: data?.erData ? { ...data } : { erData: data }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.util.isDialogOpen$.set(false);
    });
  }

  redirectToDetailedER(pageType: string, courseId: any, instanceId: any) {
    const queryParams = new URLSearchParams();
    queryParams.append('pageType', pageType);
    queryParams.append('course', courseId);
    queryParams.append('instance', instanceId);
    if (this.util.studentTypeToggleRestrict$()?.val)
      queryParams.append('studentType', this.util.studentTypeToggleRestrict$().val?.studentTypeId)
    this.router.navigateByUrl(`/manage-er/1?${queryParams.toString()}`);
  }

  downloadStagesModulesReport(institutionId: any): any {
    const userId = Number(this.util.getStoredUserDetails().userId ?? 0);
    return this.easyLoadService.initDownload(institutionId, userId, this.reportConstants.STAGES_MODULE_REPORT).pipe(take(1));
  }

  openUploadPopup(institutionId: any): any {
    this.util.isDialogOpen$.set(true);
    const dialogRef = this.dialog.open(UploadReportComponent, {
      panelClass: 'upload_report',
      width: '512px',
      data: { fromPage: 'stagesModules', institutionId: institutionId }
    });
    return dialogRef.afterClosed();
  }

  openModuleReportList(institutionDetails: any, pageName: string, reportTitle: string) {
    this.util.isDialogOpen$.set(true);
    const dialogRef = this.dialog.open(ReportListingPopupComponent, {
      panelClass: 'report-listing-popup',
      width: '1012px',
      data: { institutionId: institutionDetails?.institutionId, fromPage: pageName, popupTitle: institutionDetails?.institutionName + ' - ' + reportTitle + ' report' }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.util.isDialogOpen$.set(false);
    })
  }
}
